// extracted by mini-css-extract-plugin
export default {"container":"InformationCard_container__lsQp3","title":"InformationCard_title__vByo8","information":"InformationCard_information__Y6FQl","point":"InformationCard_point__+h-Ud"};